/*
*
* File JS componente Animation
*
*/

// IMPORT MODULES
//----------------------------------------------------------------------------//

//import inView from 'in-view';
import PercentView from '../../js/plugin/percentview';


// IMPORT SCSS PER LA COMPILAZIONE
//----------------------------------------------------------------------------//

import './animation.scss';

//----------------------------------------------------------------------------//


// EXPORT COMPONENTE
//----------------------------------------------------------------------------//
const allAnimation =
{
    'bottom-to-top': (item) =>
    {
        allAnimation.onlyCssAnimation(item);
    },

    'opacity': (item) =>
    {
        allAnimation.onlyCssAnimation(item);
    },

    'card-bottom-to-top': (item) =>
    {
        allAnimation.onlyCssAnimation(item);
    },

    /**
    *   Animazioni semplici, tutto via css
    *
    *   @param  {node} item Il nodo del dom
    *
    *   @return {void}
    */
    onlyCssAnimation: (item) =>
    {
        const threshold = item.dataset.animmThreshold-0 || 0.9;
        const delay = item.dataset.animmDelay-0 || 0;

        const inView = new PercentView(item,
        {
            onScrollInside: (e, t) =>
            {
                if( e.topInView <= threshold )
                {
                    t.destroy();
                    setTimeout(()=>
                    {
                        item.classList.add('start-animation');
                    }, delay);
                }
            }
        });
    }
}

const animation = () =>
{
    const animItems = document.querySelectorAll('[data-animm]');

    animItems.forEach(animationItem);
}

const animationItem = (item) =>
{
    const type = item.dataset.animm;

    if( allAnimation.hasOwnProperty(type) )
    {
        allAnimation[type](item);
    }
}

export { animation, animationItem };

//export default () => {
//    return {animation, animationItem};
//}

//----------------------------------------------------------------------------//